import MonetaryFormatter from "../helper/MonetaryFormatter";
import Vue from "vue";

const formatter = new MonetaryFormatter();

Vue.filter("currency", function(price, currency = App.activeCurrency, customFormat = "", customPattern = "") {
	if (price === "N / A") {
		return price;
	}

	formatter.setPattern(customPattern.length > 0 ? customPattern : App.currencyPattern.pattern);

	return formatter.format(parseFloat(price), currency, customFormat);
});
